<template>
  <div class="">
    <app-splash-screen v-if="loginCallInProgress"></app-splash-screen>
    <app-login v-if="!loginCallInProgress && !isUserLoggedIn"></app-login>
    <app-main v-if="!loginCallInProgress && isUserLoggedIn"></app-main>
  </div>
</template>

<script>
import axios from 'axios'

// MIXINS
import { Good3Lib } from './good3lib/good3_lib'

// VUEX
import { mapGetters } from 'vuex'

// COMPONENTS
import LoginPage from './components/Login.vue'
import MainPage from './components/Main.vue'
import SplashScreen from './components/Splash.vue'
// import DebugPane from './components/Debug.vue'

// DEFAULT
export default {
  name: 'GOOD3',

  // Importing VUEJS shared resources
  //
  // • props for input
  // • components for sub vue components
  // • mixins for methods libraries
  props: {},
  components: {
    'app-login': LoginPage,
    'app-main': MainPage,
    'app-splash-screen': SplashScreen
    // 'app-debug': DebugPane
  },
  mixins: [Good3Lib],

  // Accessible properties
  //
  // • data
  // • computed
  // • watch
  data: () => ({
  }),
  computed: {
    // FROM VUEX
    ...mapGetters([
      'isUserLoggedIn',
      'loginCallInProgress'
    ])
  },
  watch: {},

  // VUEJS lifecycle hooks
  //
  // • created
  // • mounted
  created () {
    // do something after creating vue instance
    axios.get(this.helpMeBackendURLForPath('good3?action=getCurrentUser'), { timeout: 3000 })
      .then(response => {
        this.handleGetCurrentUserCall(response)
      })
      // 404 is caught here
      .catch(error => {
        this.$store.commit('endGetCurrentUserCall', 'done')
      })
  },

  // Components methods
  methods: {
    // handleGetCurrentUserCall verifies that there was no error at the HTTP
    // layer and no error at the application layer and stores the current user
    // information.
    handleGetCurrentUserCall (pResponse) {
      // basic sanity check
      if ((!pResponse) ||
        // checking the HTTP layer
        (pResponse.status !== 200) ||
        // checking the application layer
        !pResponse.data ||
        pResponse.data.error ||
        !pResponse.data.data
      ) {
        // login call is done
        this.$store.commit('endGetCurrentUserCall', 'done')
        return
      }

      // we have the user object into pResponse.data.data
      var vCurrentUser = pResponse.data.data
      this.$store.commit('logUserIn', vCurrentUser)

      // login call is done
      this.$store.commit('endGetCurrentUserCall', 'done')
    }
  }
}
</script>

<style>
  @import './assets/good3.css';
</style>
